module.exports = __webpack_public_path__ + "img/1557614108345442305.718a786c.png";